import { useTranslation } from "react-i18next";
import { getStepFromStatus } from "../hooks/statusTranslate";
import { useEffect, useState } from "react";

const ORDER_STEPS_KEYS = [
    "statusTracker.OrderPlaced",
    "statusTracker.Packed",
    "statusTracker.Shipped",
    "statusTracker.OutforDelivery",
    "statusTracker.Delivered",
];

const RETURN_STEPS_KEYS = [
    "statusTracker.OrderPlaced",
    "statusTracker.Packed",
    "statusTracker.Shipped",
    "statusTracker.OutforDelivery",
    "statusTracker.Delivered",
    "statusTracker.ReturnInitiated",
    "statusTracker.Refunded",
];

const NORMAL_STATUS_MAP = {
    pending: 1,
    payment_pending: 1,
    order_placed: 1,
    placed: 1,
    ORDER_RECEIVED: 1,
    created: 1,

    processing: 2,
    packed: 2,
    label_created: 2,

    shipped: 3,
    in_transit: 3,
    transit: 3,
    sendcloud_in_transit: 3,

    out_for_delivery: 4,
    delivery_attempt: 4,

    delivered: 5,
    delivery_delivered: 5,
};

const RETURN_STATUS_MAP = {
    ...NORMAL_STATUS_MAP,

    return_requested: 6,
    return_request: 6,
    return_initiated: 6,
    return_label_created: 6,
    return_in_transit: 6,
    return_transit: 6,
    return_delivered_to_seller: 6,
    returned: 6,

    refunded: 7,
    refund_processed: 7,
    return_completed: 7,
    order_closed: 7,
};

const CheckIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const StatusTracker = ({
    isReturn = false,
    isRefunded = false,
    status,
    hasParcel = true,
    className = "",
}) => {
    const { t } = useTranslation();
    const [stepProp, setCurrentStep] = useState(1);

    useEffect(() => {
        let step = getStepFromStatus(isReturn, isRefunded, status);
        // AWAITING_SHIPMENT: stay on this step until parcel_id is available
        if (!isReturn && !isRefunded && step === 2 && !hasParcel) step = 1;
        setCurrentStep(step+1);
    }, [status, isReturn, isRefunded, hasParcel]);

    const stepKeys = isReturn ? RETURN_STEPS_KEYS : ORDER_STEPS_KEYS;
    const steps = stepKeys.map((key, idx) => ({
        id: idx + 1,
        label: t(key),
    }));
    const resolvedStep = Math.max(
        1,
        Math.min(stepProp ?? getStepFromStatus(isReturn, isRefunded, status), steps.length+1)
    );
    const progressPct = ((resolvedStep - 1) / (steps.length - 1)) * 100;

    return (
        <div className={`st-wrapper ${className}`}>
            <div className="st-bar-rail">
                <div
                    className="st-bar-fill"
                    style={{ width: `${progressPct}%` }}
                />
            </div>

            <div className="st-steps">
                {steps.map((step) => {
                    const isDone = step.id < resolvedStep;

                    const isActive = step.id === resolvedStep;

                    const circleClass = isDone
                        ? "st-circle done"
                        : isActive
                            ? "st-circle active"
                            : "st-circle";

                    return (
                        <div key={step.id} className="st-step">
                            <div className={circleClass}>
                                {isDone ? (
                                    <CheckIcon />
                                ) : (
                                    <span className="st-step-num">{step.id}</span>
                                )}
                            </div>

                            <p className={`st-label ${isActive ? "st-label-active" : ""}`}>
                                {step.label}
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default StatusTracker;
